import { ISelectMultiOption } from '@salecycle/ui-component-library';
import { useCallback } from 'react';
import { ISegmentFilter } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { useOffsiteCampaignEditorDispatch } from 'sections/offsite-campaigns/offsite-campaign-editor/context/UseOffsiteCampaignEditorContext';

export const useUpdateFilterList = (segmentId: string, segmentFilter: ISegmentFilter) => {
  const dispatch = useOffsiteCampaignEditorDispatch();

  return useCallback(
    (selectedItems: ISelectMultiOption<string>[] | null) => {
      const options = selectedItems ? selectedItems.map(u => u.value) : [];
      dispatch({
        type: 'UPDATE_TESTING_FILTER_LIST',
        payload: {
          segmentId: segmentId,
          segmentFilterId: segmentFilter.id,
          options: options,
        },
      });
    },
    [dispatch, segmentFilter.id, segmentId],
  );
};
